import { NgClass } from '@angular/common'
import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  Input,
  inject,
} from '@angular/core'
import { MatIconModule } from '@angular/material/icon'

export type Punctuation = '.' | '!'

@Component({
  selector: 'wm-front-bullet-point',
  templateUrl: './bullet-point.component.html',
  styleUrls: ['./bullet-point.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [MatIconModule, NgClass],
})
export class BulletPointComponent {
  /** Text to display */
  public currentText: string

  /** Color to display. */
  public currentColor?: string

  /** The punctuation to display. By default a point. */
  public currentPunctuation?: Punctuation

  /** The number of puncutation to display */
  public currentNumberOfPunctuation?: number

  /** The icon to display. */
  public icon?: string

  protected _cdf = inject(ChangeDetectorRef)

  /** Will set the text at component level. It should already be translated */
  @Input()
  public set text(text: string) {
    this.currentText = text
    this.detectChange()
  }

  /** Will set the text at component level */
  @Input()
  public set color(color: string) {
    this.currentColor = color.toLowerCase()
    this.detectChange()
  }

  /** Will set the text at component level */
  @Input()
  public set punctuation(punctuation: Punctuation | undefined) {
    this.currentPunctuation = punctuation
    this.setIconFromPunctuation()
    this.detectChange()
  }

  /** Will set the text at component level */
  @Input()
  public set numberOfPunctuation(numberOfPunctuation: number | undefined) {
    this.currentNumberOfPunctuation = numberOfPunctuation
    this.detectChange()
  }

  /** Will trigger the change detector to fire */
  private detectChange(): void {
    this._cdf.markForCheck()
  }

  /**
   * Will set the icon from the punctuation
   * @private
   */
  private setIconFromPunctuation(): void {
    switch (this.currentPunctuation) {
      case '.':
        this.icon = 'point-xs'
        break
      case '!':
        this.icon = 'exclamation-xs'
        break
    }
  }
}
